<template>
  <v-form ref="userGroupForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="4">
        <v-text-field
          :rules="inputRules"
          outlined
          dense
          label="Name"
          v-model="record.name"
        ></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true,
    },
    docCreate: {
      type: Boolean,
    },
  },
  data: () => ({
    inputRules: [v => !!v || "Required"],
    valid: false,
    lazy: false,
    record: {},
    loader: false,
    stores: [],
    storesArray: [],
    date: new Date().toISOString().substr(0, 10),
    roles: [
      { name: "Subscriber", role: 3 },
      { name: "Admin", role: 2 },
      { name: "Cashier", role: 1 },
    ],
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.userGroupForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      this.loader = true;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
  },
  created() {
  },
};
</script>